// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Money20CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Money20Circle: FC<Money20CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path
                d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm-.75-6.667V19h1.5v-1.604c.889-.14 1.59-.48 2.104-1.021.514-.542.771-1.208.771-2s-.222-1.444-.667-1.958c-.444-.514-1.152-.93-2.125-1.25-.944-.32-1.59-.608-1.937-.865s-.521-.566-.521-.927c0-.361.16-.667.48-.917.319-.25.721-.375 1.207-.375.403 0 .771.118 1.105.354.333.237.555.535.666.896l1.459-.604a95.78 95.78 0 0 0-.532-.937c-.34-.598-1.01-.98-2.01-1.146V5h-1.5v1.646c-.764.153-1.372.479-1.823.979a2.582 2.582 0 0 0-.677 1.792c0 .736.25 1.337.75 1.802.5.465 1.292.892 2.375 1.281.792.278 1.344.556 1.656.833.313.278.469.625.469 1.042 0 .444-.174.806-.52 1.083-.348.278-.793.417-1.334.417-.486 0-.955-.198-1.406-.594-.452-.396-.733-.844-.844-1.344l-1.542.626a3.99 3.99 0 0 0 1.073 1.812 3.709 3.709 0 0 0 1.823.958Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Money20Circle;
